import { useSelector } from 'react-redux';
import { RootState } from '../store';

export const useProductName = (cardName?: string) => {
  const { contentfulData } = useSelector(
    (state: RootState) => state.contentful
  );
  const { accountDetails } = useSelector((state: RootState) => state.user);

  // Use provided cardName or fall back to account details
  const name = cardName || accountDetails?.productName;

  // Early return with default values if no name or required data
  if (!name || !contentfulData) {
    return {
      productName: 'Rogers Master Card',
      cardStructure: {
        imgUrl: undefined,
        isHorizontal: false,
      },
    };
  }

  const { assets, entries } = contentfulData;
  const cardImageMap = entries?.rb_digital_cardview?.cardImageMap || {};
  // console.log('Card Image Map --', cardImageMap);
  const cardInfo = cardImageMap[name] || {};

  // Use optional chaining and nullish coalescing for safer access
  return {
    productName:
      entries?.rb_digital_cardview?.productName[name] || 'Rogers Master Card',
    cardStructure: {
      imgUrl: assets[cardInfo.imgUrl],
      isHorizontal: cardInfo.isHorizontal || false,
    },
  };
};
